<div class="main-container">
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>
  <div class="search-label-container">
    <label class="lbl-supplier-search" for="supplier">
      {{labelText}}
      <img src="./assets/SkyWhite-min.png" alt="Icon" class="label-icon" />
    </label>
  </div>
  <div class="scrollable-form-wrapper">
    <form class="form-fields-container" [formGroup]="form" (ngSubmit)="search()">
      <div formArrayName="fields">
        <div *ngFor="let fieldGroup of fields.controls; let i = index" [formGroupName]="i" class="criteria-row">

          <!-- Logical Operator Label -->
          <div *ngIf="i !== 0 && fieldGroup.value.logicalOperator === 'OR'" class="logical-operator-label">{{ fieldGroup.value.logicalOperator }}</div>

          <!-- Field Dropdown -->
          <select class="dropDownFieldselect" formControlName="selectedField"
                  (blur)="fieldGroup.get('selectedField')?.markAsTouched()">
            <option value="" disabled>Select Field</option>
            <option *ngFor="let option of fieldOptions" [value]="option">{{ option }}</option>
          </select>

          <!-- Operator Dropdown -->
          <select class="dropDownOperator" formControlName="operator">
            <option *ngFor="let option of operatorOptions" [value]="option">{{ option }}</option>
          </select>

          <!-- Textbox -->
          <input type="text" class="txtSearchBox" formControlName="fieldValue" placeholder="Enter value" />

          <!-- AND / OR Buttons -->
          <ng-container *ngIf="fieldGroup.get('selectedField')?.value && fieldGroup.get('showButtons')?.value">
            <button *ngIf="fieldGroup.value.logicalOperator !== 'OR'" type="button" class="btnAddAndField" (click)="addFieldWithOperator('AND', i)">AND</button>
            <button type="button" class="btnAddOrField" (click)="addFieldWithOperator('OR', i)">OR</button>
          </ng-container>

          <!-- Cancel Button -->
          <button class="btnRemoveField" type="button" aria-label="Remove field" (click)="removeField(i)" *ngIf="fields.length > 1">X</button>
        </div>
      </div>
    </form>

    <div class="search-button-container">
      <button class="btnSearch" type="submit" (click)="search()">Search</button>
    </div>
  </div>
  <!-- Search Summary -->

  <div class="grid-container">
    <table mat-table [dataSource]="suppliers" matSort class="mat-elevation-z8">
      <!-- Supplier ID Column -->
      <ng-container matColumnDef="supplierId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Id </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.supplierId }} </td>
      </ng-container>

      <!-- Supplier Name Column -->
      <ng-container matColumnDef="supplierName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Name </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.supplierName }} </td>
      </ng-container>

      <!-- City Column -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> City </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.city }} </td>
      </ng-container>

      <!-- Country Column -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Country </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.country }} </td>
      </ng-container>

      <!-- Group Key Column -->
      <ng-container matColumnDef="groupKey">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Group Key </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.groupKey }} </td>
      </ng-container>

      <!-- Group Key Description Column -->
      <ng-container matColumnDef="groupKeyDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Allowed Invoice Type & Delivery Method</th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.groupKeyDescription }} </td>
      </ng-container>

      <!-- VAT Number Column -->
      <ng-container matColumnDef="vatNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> VAT Number </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.vatNumber }} </td>
      </ng-container>

      <!-- Company Number Column -->
      <ng-container matColumnDef="companyNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Company Number </th>
        <td mat-cell *matCellDef="let supplier"> {{ supplier.companyNumber }} </td>
      </ng-container>

      <!--<ng-container matColumnDef="supplierConfirmed">
    <th mat-header-cell *matHeaderCellDef> Supplier Confirmed </th>
    <td mat-cell *matCellDef="let supplier">
      <mat-checkbox [checked]="supplier.supplierConfirmed" disabled></mat-checkbox>
    </td>
  </ng-container>-->

      <ng-container matColumnDef="poVendor">
        <th mat-header-cell *matHeaderCellDef> PO Vendor </th>
        <td mat-cell *matCellDef="let supplier">
          <mat-checkbox [checked]="supplier.poVendor" disabled></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="inactive">
        <th mat-header-cell *matHeaderCellDef> Inactive </th>
        <td mat-cell *matCellDef="let supplier">
          <mat-checkbox [checked]="supplier.inactive" disabled></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="blocked">
        <th mat-header-cell *matHeaderCellDef> Blocked</th>
        <td mat-cell *matCellDef="let supplier">
          <mat-checkbox [checked]="supplier.blocked" disabled></mat-checkbox>
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="no-data"
            [attr.colspan]="displayedColumns.length"
            *ngIf="hasRecords && !isLoading">
          No records to display
        </td>
      </tr>

      <!-- Header and Row Declaration -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

  </div>
</div>
